import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Walnuts.css";

export default function Walnuts() {

    const WalnutsProducts = [
        {
            id: 1,
            name: "WALNUT KERNELS",
            image: "/assets/img/Walnuts/Walnut-Kernels.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Breakfast cereals",
                        "Healthy snack mixes",
                        "Confectionery industry",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Ready-to-use form",
                        "Rich in Omega-3",
                        "Excellent nutritional value",
                        "Premium taste and texture",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "WALNUT HALVES",
            image: "/assets/img/Walnuts/Walnut-Halves.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Premium bakery products",
                        "Desserts and sweets",
                        "Retail dry fruit packs",
                        "Luxury food products",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Uniform appearance",
                        "Premium quality grade",
                        "Excellent flavor",
                        "High market demand",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "WALNUT PIECES",
            image: "/assets/img/Walnuts/Walnut-Pieces.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Food processing industries",
                        "Bakery fillings",
                        "Chocolate manufacturing",
                        "Nut-based products",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Cost-effective option",
                        "Easy to process",
                        "Maintains walnut flavor",
                        "Ideal for bulk production",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "IN-SHELL WALNUTS",
            image: "/assets/img/Walnuts/In-Shell-Walnuts.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Retail dry fruit packs",
                        "Snack food products",
                        "Gift packaging",
                        "Traditional food markets",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Natural freshness protection",
                        "Long shelf life",
                        "Premium appearance",
                        "High consumer demand",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Walnut (Akhrot)"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Walnut Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality Walnut (Akhrot) products sourced from
                        trusted suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {WalnutsProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}